<script setup lang="ts">
import type { CartGoal } from "@/schemas/cart";
import SvgDropletShipping from "@/svg/droplet-shipping.svg";
import SvgDropletLillopoints from "@/svg/droplet-lillopoints.svg";

const { cart } = useCart();
const goalItems = computed(() => {
  function goalItem(goal: CartGoal) {
    switch (goal.goal_type) {
      case "free_shipping":
        return { component: SvgDropletShipping, label: "Livraison gratuite", description: "la livraison gratuite" };
      case "lillopoints":
        return { component: SvgDropletLillopoints, label: integer(goal.lillopoints), description: `un bonus de ${integer(goal.lillopoints)} Lillopoints` };
    }
  }
  return cart.value.goals.map((goal) => ({ ...goal, ...goalItem(goal) }));
});

const maxAmount = computed(() => cart.value.goals[cart.value.goals.length - 1]?.amount || 300);
const curGoal = computed(() => goalItems.value.findLast((goal) => cart.value.totals.subtotal >= goal.amount));
const nextGoal = computed(() => goalItems.value.find((goal) => cart.value.totals.subtotal < goal.amount));
</script>

<template>
  <div class="relative flex flex-col gap-8 rounded-lg border-2 border-primary p-6">
    <span class="i-local-rewards absolute -left-4 top-1/2 size-8 -translate-y-1/2" />
    <div class="prose">
      <p v-if="curGoal">
        Félicitation, vous obtiendrez <span class="font-bold text-primary">{{ curGoal.description }}</span> suite à cette commande!
      </p>
      <p v-if="nextGoal">
        Ajoutez <span class="font-semibold text-primary">{{ currency(nextGoal.amount - cart.totals.subtotal) }}</span> pour obtenir <span class="font-bold text-primary">{{ nextGoal.description }}</span>!
      </p>
      <p class="text-sm">
        * La commande doit être expédiée en un seul envoi pour profiter du bonus de points.
      </p>
    </div>
    <div class="relative my-4">
      <div class="overflow-hidden rounded-full bg-light">
        <div class="h-6 bg-primary" :style="`width: ${cart.totals.subtotal / maxAmount * 100}%`" />
      </div>
      <div v-for="(goal, i) in goalItems" :key="i" class="absolute top-0 flex -translate-x-1/2 -translate-y-8 flex-col items-center" :style="`left: ${goal.amount / maxAmount * 100}%`">
        <Component :is="goal.component" class="size-8" />
        <div class="h-6" />
        <span class="text-xs">{{ goal.label }}</span>
      </div>
    </div>
  </div>
</template>
